<template>
  <div class="card">
    <form enctype="multipart/form-data"
          @submit.prevent="create"
          @keydown="form.onKeydown($event)"
    >

      <div v-if="title" class="card-header">
        <div>
          {{ title }}
        </div>
        <div class="import-block">
          <input v-show="checkCreateModulePage" :class="{ 'is-invalid': form.errors.has('file') }"
                 class="form-control-file input-card"
                 type="file"
                 name="file"
                 @change="selectFile"
          >
          <!--<HintImport :form="form" field="field" />-->
          <!--<has-error :form="form" field="file" />-->
          <alert-success :form="form" :message="'asdasdsadsad'"/>

          <v-button v-show="checkCreateModulePage" :loading="form.busy">
            {{ $t('create') }}
          </v-button>
        </div>
      </div>

    </form>
    <div class="card-body">
      <slot />
    </div>
  </div>
</template>

<script>
import Form from 'vform'

import objectToFormData from 'object-to-formdata'

import HintImport from '../../js/components/admin/HintImport'
import AlertSuccess from "vform/src/components/AlertSuccess";

export default {
  name: 'Card',
  components: {
    AlertSuccess,
    HintImport
  },

  props: {
    title: {
      type: String,
      default: null
    },

    page: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    form: new Form({
      file: ''
    })
  }),

  computed: {
    checkCreateModulePage () {
      return this.page === 'moduleCreate'
    }
  },

  methods: {

    selectFile (e) {
      this.form.file = e.target.files[0]
    },

    async create () {
      // Submit the form.
      const {data} = await this.form.submit('post', '/api/module/import', {
        // Transform form data to FormData
        transformRequest: [function (data, headers) {
          return objectToFormData(data)
        }]
      })

    }
  }
}
</script>

<style scoped>
  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .input-card {
    width: inherit;
  }
  .import-block {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Card.vue